<template>
  <div class="pt-16">
    <h2 class="pt-6 pb-3">Bulk Upload CSV</h2>
    <v-container>
      <v-tabs v-model="uploadType" fixed-tabs background-color="primary" dark>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />VoIP
          Services
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />Misc
          Transactions
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />New
          Mobiles
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />New
          Customers
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload
          <br />Disconnect Services
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />NBN
          Services
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />MNF
          Agents
        </v-tab>
      </v-tabs>

      <v-tabs-items>
        <h3 v-text="getUploadType" class="pt-8"></h3>
        <v-card>
          <v-row align="center" no-gutters class="mt-8">
            <input type="file" hidden id="logFile" />
            <v-col cols="4">
              <v-file-input
                outlined
                dense
                clearable
                @click:clear="reset"
                label="File input"
                v-model="file"
                @change="readCSV"
                class="mt-8"
              ></v-file-input>
            </v-col>
            <v-col cols="8">
              <v-row class="uploadbtns pt-2" align="center">
                <v-col cols="3">
                  <v-btn @click="upload">Submit Data</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn @click="downloadCsvExample">Example Data</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn @click="csvExport">Results Data</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="excludePayment"
                    v-if="uploadType == 0 || uploadType == 2 || uploadType == 4"
                    label="Exclude from commissions payment"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-tabs-items>
    </v-container>
    <v-container>
      <v-dialog eager v-model="show" persistent max-width="50%">
        <field-settings
          ref="config"
          @updateHeader="updateHeader"
          @close="close"
        ></field-settings>
      </v-dialog>
      <v-dialog eager v-model="showPrompt" persistent max-width="50%">
        <v-card>
          <v-card-title class="text-h5">
            <span class="headline">
              <v-icon left>mdi-alert-circle-outline</v-icon>
              <span>Confirm</span>
            </span>
          </v-card-title>

          <v-card-text class="body-1">
            The file contains more than 200 lines of data, so line by line
            success/failure will only be displayed once the import is finished
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="showPrompt = false"> Ok </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card>
        <ag-grid-vue
          style="height: 500px"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :defaultColDef="defaultColDef"
          @grid-ready="onGridReady"
          rowSelection="multiple"
        ></ag-grid-vue>
      </v-card>
    </v-container>
    <ProcessLoader ref="loader" :loaded="loaded" :uploadData="rowData.length" />
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { HTTP } from "@/http-common";
import {
  voipServicesHeaders,
  transactionsHeaders,
  newMobilesHeaders,
  disconnectHeaders,
  nbnHeaders,
  mnfHeaders,
  customerHeaders,
  customerExampleHeader,
} from "@/data/csvHeaders";
import {
  voipServicesExample,
  transactionsExample,
  newMobilesExample,
  disconnectExample,
  nbnExample,
  customerExample,
} from "@/data/csvExampleData";
import {
  VoipService,
  createVoipServiceWithHeaderName,
} from "@/models/VoipService";
import {
  Transaction,
  createTransactionWithHeaderName,
} from "@/models/Transaction";
import { Customer, createCustomer } from "@/models/Customer";
import {
  DisconnectService,
  createDisconnectServiceWithHeaderName,
} from "@/models/DisconnectService";
import parse from "csv-parse";
import ProcessLoader from "@/components/process-loader";
import FieldSettings from "@/components/field-settings";
import { mnfAgentExampleData } from "../data/csvExampleData";

export default {
  name: "BulkUploadCSV",
  components: {
    AgGridVue,
    ProcessLoader,
    FieldSettings,
  },
  data: () => ({
    file: null,
    uploadType: 0,
    handler: null,
    exampleData: null,
    rowData: null,
    columnDefs: null,
    gridApi: null,
    gridOptions: null,
    defaultColDef: {
      resizable: true,
    },
    loaded: 0,
    uploadData: {
      size: 0,
      failed: 0,
      success: 0,
    },
    show: false,
    filecopy: null,
    excludePayment: false,
    showPrompt: false,
    log: null,
  }),
  mounted() {
    this.updateColumnNames();
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeMount() {
    this.gridOptions = { defaultToolPanel: "" };
    this.columnDefs = [];
    this.rowData = [];
  },
  computed: {
    getUploadType() {
      switch (this.uploadType) {
        case 0:
          return "Upload VoIP services";
        case 1:
          return "Upload Misc Transactions";
        case 2:
          return "Upload New Mobiles";
        case 3:
          return "Upload New Customers";
        case 4:
          return "Upload Disconnect Services";
        case 5:
          return "Upload NBN Services";
        case 6:
          return "Upload MNF Agents";
        default:
          return "Upload VoIP services";
      }
    },
  },

  methods: {
    onGridReady(args) {
      this.gridApi = args.api;
    },
    readCSV(item) {
      if (item) {
        try {
          var vm = this;
          vm.filecopy = item;
          if (!vm.file.name.toLowerCase().includes("csv")) {
            alert("Please upload CSV File.");
            return;
          }
          vm.rowData = [];
          this.updateColumnNames();
          new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsText(item);
            reader.onload = (e) => {
              parse(
                reader.result,
                {
                  columns: true,
                  skip_empty_lines: true,
                  relax_column_count: true,
                },
                function (err, output) {
                  if (err) {
                    vm.errorMessage = err;
                    reject(err);
                  } else {
                    vm.rowData = output.filter((x) => {
                      var filtered = Object.keys(x).filter(
                        (key) => x[key] != ""
                      );
                      return filtered.length > 0 ? x : "";
                    });
                    if (vm.rowData.length) {
                      vm.$refs.config.fileHeaders = Object.keys(
                        vm.rowData[0]
                      ).map((e) => {
                        return {
                          headerName: e,
                          field: e,
                        };
                      });
                      vm.show = true;
                    }
                    //vm.createObjectWithHeader(output);
                    // vm.$forceUpdate();
                    vm.gridApi.sizeColumnsToFit();
                    vm.uploadData.size = output.length;
                    resolve(output);
                  }
                }
              );
            };
          });
        } catch (error) {
          throw error;
        }
      }
    },
    onUpload() {
      let vm = this;
      let formData = new FormData();
      if (vm.file != null || vm.filecopy != null) {
        formData.append("file", vm.file || vm.filecopy);
        this.bulkUpload(formData)
          .then((data) => {
            this.rowData = data.data;
            this.$forceUpdate();
          })
          .catch(() => {});
      }
    },
    formatDate(str) {
      let date = "";
      if (str || str !== "NULL") {
        let splitParts = str.split("/");
        date = `${splitParts[2]}-${splitParts[1]}-${splitParts[1].length}`;
      }
      return new Date(date) == "Invalid date" ? "" : date;
    },
    async upload() {
      let vm = this;
      let rowData = [];
      vm.$refs.loader.show = true;
      await Promise.all(
        vm.rowData.map((data, i) => {
          if (data.csn && data.csn.length > 8) data.mobileNumberMsn = data.csn;
          data.excludePayment = vm.excludePayment;
          data.contractLength = +data.contractLength;
          data.success = false;
          data.reason = "";
          return new Promise((resolve, reject) => {
            let response = HTTP.post("BulkUpload/" + vm.handler, data);
            response
              .then((res) => {
                if (res.data.length == 0) {
                  rowData.push(data);
                  returnData;
                }
                let returnData = { ...data, ...res.data[0] };
                returnData.success = res.data.success;
                returnData.reason = res.data[0].reason;
                switch (vm.uploadType) {
                  case 0:
                    returnData.success = res.data[0].success;
                    returnData.reason =
                      res.data[0].message || res.data[0].reason;
                    break;
                  case 1:
                    returnData = { ...data, ...res.data.data[0].return };
                    if (!returnData.isError) {
                      returnData.success = true;
                      returnData.reason = "Ok";
                    } else {
                      returnData.success = false;
                      returnData.reason = res.data.message || res.data.reason;
                    }
                    break;
                  case 5:
                    returnData = { ...data, ...res.data.data };
                    break;
                  default:
                    if (returnData.success) {
                      returnData.success = true;
                    } else {
                      returnData.success = false;
                    }
                    break;
                }
                rowData.push(returnData);
                vm.closeModal();
                resolve(data);
              })
              .catch((err) => {
                let returnData = {
                  ...data,
                  success: false,
                  reason: err?.response?.data,
                };
                rowData.push(returnData);
                vm.closeModal();
                reject(rowData);
              })
              .finally(() => {
                vm.closeModal();
                ++this.loaded;
                if (this.loaded == this.rowData.length) {
                  vm.$refs.loader.show = false;
                }
              });
          });
        })
      )
        .then(() => {
          vm.$refs.loader.show = false;
          vm.rowData = rowData;
          this.gridApi.setRowData(vm.rowData);
          vm.uploadLogs(rowData);
        })
        .catch((err) => {
          vm.rowData = err;
          this.gridApi.setRowData(vm.rowData);
          vm.uploadLogs(vm.rowData);
          vm.$refs.loader.show = false;
        })
        .finally(() => {
          vm.$refs.loader.show = false;
          this.loaded = 0;
        });
    },
    bulkUpload(formData) {
      let vm = this;
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/" + vm.handler, formData);
        response
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    healthCheck() {
      return new Promise((resolve, reject) => {
        let response = HTTP.get("BulkUpload/HealthCheck");
        response
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    csvExport() {
      var arrData = this.rowData;
      var rows = [];
      rows.push(this.columnDefs.map((item) => item.headerName));
      rows = rows.concat(this.convertJson(arrData));
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "uploadResult.csv");
      link.click();
    },
    downloadCsvExample() {
      this.updateColumnNames();
      var rows = [];
      var headers =
        this.uploadType == 3 ? customerExampleHeader : this.columnDefs;

      rows.push(headers.slice(0, headers.length - 2).map((item) => item.field));
      rows = rows.concat(this.exampleData);
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", this.handler + "ExampleData.csv");
      link.click();
    },
    convertJson(arrData) {
      if (
        this.handler == "bulkUploadVoipServices" ||
        this.handler == "bulkUploadMobileServices"
      ) {
        return arrData.map((item) => Object.values(new VoipService(item)));
      } else if (this.handler == "bulkUploadTransactions") {
        return arrData.map((item) => Object.values(new Transaction(item)));
      } else if (this.handler == "bulkUploadDisconnectServices") {
        return arrData.map((item) =>
          Object.values(new DisconnectService(item))
        );
      } else if (this.handler == "bulkUploadCustomers") {
        let data = arrData.map((item) => Object.values(new Customer(item)));

        return data;
      }
    },
    createObjectWithHeader(arrData) {
      if (
        this.handler == "bulkUploadVoipServices" ||
        this.handler == "bulkUploadMobileServices"
      ) {
        return arrData.map((item) => createVoipServiceWithHeaderName(item));
      } else if (this.handler == "bulkUploadTransactions") {
        return arrData.map((item) => createTransactionWithHeaderName(item));
      } else if (this.handler == "bulkUploadDisconnectServices") {
        return arrData.map((item) =>
          createDisconnectServiceWithHeaderName(item)
        );
      }
    },
    reset() {
      this.rowData = [];
      this.columnDefs = [];
      this.exampleData = null;
      this.formData = null;
      this.file = null;
    },
    updateColumnNames() {
      switch (this.uploadType) {
        case 0:
          this.$refs.config.setHeader(voipServicesHeaders);
          this.columnDefs = voipServicesHeaders;
          this.handler = "bulkUploadVoipServices";
          this.exampleData = voipServicesExample;
          break;
        case 1:
          this.$refs.config.setHeader(transactionsHeaders);
          this.columnDefs = transactionsHeaders;
          this.handler = "bulkUploadTransactions";
          this.exampleData = transactionsExample;
          break;
        case 2:
          this.$refs.config.setHeader(newMobilesHeaders);
          this.columnDefs = newMobilesHeaders;
          this.handler = "bulkUploadMobileServices";
          this.exampleData = newMobilesExample;
          break;
        case 3:
          this.$refs.config.setHeader(customerHeaders);
          this.columnDefs = customerHeaders;
          this.handler = "  ";
          this.exampleData = customerExample;
          break;
        case 4:
          this.$refs.config.setHeader(disconnectHeaders);
          this.columnDefs = disconnectHeaders;
          this.handler = "bulkUploadDisconnectServices";
          this.exampleData = disconnectExample;
          break;
        case 5:
          this.$refs.config.setHeader(nbnHeaders);
          this.columnDefs = nbnHeaders;
          this.handler = "bulkUploadNBNServices";
          this.exampleData = nbnExample;
          break;
        case 6:
          this.$refs.config.setHeader(mnfHeaders);
          this.columnDefs = mnfHeaders;
          this.handler = "BulkUploadInterestedAgents/44";
          this.exampleData = mnfAgentExampleData;
          break;
        default:
          this.$refs.config.setHeader(voipServicesHeaders);
          this.columnDefs = voipServicesHeaders;
          this.handler = "bulkUploadVoipServices";
          this.exampleData = voipServicesExample;
          break;
      }
    },
    getPercentage(partialValue) {
      const percent = (100 * partialValue) / this.uploadData.size;
      this.loaded = percent;
      return percent;
    },
    closeModal() {
      let vm = this;
      if (vm.$refs.loader.getPendingCount === 0) {
        vm.$refs.loader.show = false;
        vm.uploadData.success = 0;
        vm.uploadData.failed = 0;
        vm.loaded = 0;
      }
    },
    close() {
      let vm = this;
      vm.reset();
      vm.file = null;
      vm.show = false;
    },
    updateHeader(header, isUpdate = true) {
      try {
        this.show = false;
        this.file = null;
        let updatedRow = [];
        if (isUpdate) {
          updatedRow = this.rowData.map((el) => {
            let parsedItem = {};
            for (const col of this.columnDefs) {
              let updated = header.find((i) => i.headerName == col.headerName);
              parsedItem[col.field] = el[updated.field];
            }
            return { ...parsedItem, success: null, reason: null };
          });
          this.rowData = updatedRow;
          this.gridApi.setRowData(updatedRow);
          if (this.rowData.length >= 200) {
            this.showPrompt = true;
          }
        }
        this.$refs.config.reset();
      } catch (error) {
        throw error;
      }
    },
    uploadLogs(rowData) {
      // console.log(rowData);
      // var arrData = rowData.map((e) => {
      //   return Object.values(e);
      // });
      // debugger
      var rows = [];
      rows.push(this.columnDefs.map((item) => item.headerName));
      let arrData = rowData.map((row) => {
        return this.columnDefs
          .map((item) => item.field)
          .map((field) => {
            return row[field];
          });
      });
      rows = rows.concat(arrData);
      let csvContent = rows
        .map((e) => {
          if (e) return e.join(",");
        })
        .join("\n");
      const data = encodeURI(csvContent);
      var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      let _file = new File([blob], `${this.handler}.csv`, {
        type: "text/csv;charset=utf-8;",
        lastModified: new Date().getTime(),
      });
      let container = new DataTransfer();
      container.items.add(_file);
      document.getElementById("logFile").files = container.files;
      let logFile = document.getElementById("logFile").files[0];
      let formData = new FormData();
      formData.append("file", logFile);
      formData.append("type", this.handler.replace("/", "_"));
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/BulkUploadLogs", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        response
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  watch: {
    loaded: function (val) {
      return val;
    },
  },
};
</script>

<style scoped>
.uploadbtns button {
  font-weight: 600;
}
.v-tab {
  text-transform: capitalize;
}
.v-tab i {
  opacity: 0;
  position: absolute;
  left: 0;
  right: 70px;
  top: 7px;
}
.v-tab.v-tab--active i {
  opacity: 1 !important;
}

.custom-fab {
  position: fixed !important;
  right: 10px;
  bottom: 50px;
}
</style>
